<button [cSidebarToggle]="sidebarId" cHeaderToggler class="btn d-lg-none pe-3" toggle="visible"
  style="margin-inline-start: -14px;">
  <svg cIcon name="cilMenu" size="lg"></svg>
</button>

<div style="display: flex; align-items: center; margin-left: auto; margin-right: 2rem; gap: 6px;">
  <ng-container *ngTemplateOutlet="notifyDropdown" />
  <ng-container *ngTemplateOutlet="userDropdown" />
</div>


<ng-template #userDropdown>
  <c-dropdown [popperOptions]="{ placement: 'bottom-end' }" variant="nav-item">
    <button [caret]="false" cDropdownToggle class="py-0">
      <img src="assets/brand/logo-cambios-polar.png" alt="Cambios Polar" height="32" />
    </button>
    <ul cDropdownMenu class="pt-0 w-auto">
      <li>
        <a cDropdownItem href="#" (click)="onLogout($event)">
          <svg cIcon class="me-1" name="cilAccountLogout"></svg>
          Logout
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #messagesDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      <span class="d-inline-block my-1 mx-2 position-relative">
        <svg cIcon name="cilEnvelopeOpen" size="lg"></svg>
        @if (newMessages?.length) {
        <c-badge class="p-1" color="danger" shape="rounded-circle" position="top-end">
          <span class="visually-hidden">{{ newMessages?.length ?? 0 }} new alerts</span>
        </c-badge>
        }
      </span>
    </button>
    <div cDropdownMenu class="p-0" [ngStyle]="{minWidth: '24rem'}">
      <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top mb-2">
        <span>You have {{ newMessages?.length ?? 0 }} messages</span>
      </h6>
      @for (message of newMessages; track message.id) {
      <a cDropdownItem routerLink="{{message.link}}">
        <div class="d-flex">
          <c-avatar size="" src="./assets/images/avatars/{{message.avatar}}" status="{{message.status}}"
            class="flex-shrink-0 my-3 me-3" />
          <div class="message text-wrap">
            <div class="d-flex justify-content-between small text-body-secondary mt-1">
              <div>{{ message.from }}</div>
              <div>{{ message.time }}</div>
            </div>
            <div class="fw-semibold">
              @if (message.id < 2) { <span class="text-danger me-1">!</span>
                }
                <span>{{ message.title }}</span>
            </div>
            <div class="small text-body-secondary">
              {{ message.message }}
            </div>
          </div>
        </div>
      </a>
      }
      <div class="p-2">
        <button cButton color="primary" variant="outline" class="w-100" routerLink="apps/email/inbox">
          View all messages
        </button>
      </div>
    </div>
  </c-dropdown>
</ng-template>

<ng-template #notifyDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      <span class="d-inline-block my-1 mx-2 position-relative">
        <svg cIcon name="cilBell" size="lg"></svg>
        @if (unreadNotificationsCount > 0) {
        <c-badge class="p-1" color="danger" position="top-end" shape="rounded-circle">
          <span class="visually-hidden">{{ unreadNotificationsCount }} new alerts</span>
        </c-badge>
        }
      </span>
    </button>
    <div cDropdownMenu class="p-0 shadow" style="min-width: 320px; z-index: 9999; max-height: 500px; overflow-y: auto;">
      <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top">
        <span>Tienes {{ unreadNotificationsCount }} notificaciones nuevas</span>
      </h6>
      @for (notification of newNotifications; track notification.id) {
      <a cDropdownItem (click)="markAsRead(notification.id)" style="cursor: pointer;"
        [ngClass]="{'bg-light border-start border-primary border-4': !notification.read_at}">
        <div class="d-flex align-items-center py-2">
          <svg cIcon class="me-3 text-{{notification.color}}" name="{{notification.icon}}" size="lg"></svg>
          <div class="text-wrap">
            <div [class.fw-bold]="!notification.read_at" class="small">{{ notification.title }}</div>
            <div class="small text-body-secondary mt-1" style="max-width: 250px;">{{ notification.message }}</div>
          </div>
        </div>
      </a>
      }
      @if (newNotifications.length === 0) {
      <div class="p-4 text-center text-body-secondary small">
        No tienes notificaciones
      </div>
      }
    </div>
  </c-dropdown>
</ng-template>

<ng-template #taskDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle href>
      <span class="d-inline-block my-1 mx-2 position-relative">
        <svg cIcon name="cilListRich" size="lg"></svg>
        @if (newTasks?.length) {
        <c-badge class="p-1" color="danger" position="top-end" shape="rounded-circle">
          <span class="visually-hidden">{{ newTasks.length ?? 0 }} new alerts</span>
        </c-badge>
        }
      </span>
    </button>
    <div cDropdownMenu class="pt-0">
      <h6 cDropdownHeader class="bg-body-secondary text-body-secondary fw-semibold rounded-top">
        <span>You have {{ newTasks.length ?? 0 }} pending tasks</span>
      </h6>
      @for (task of newTasks; track task.id) {
      <a cDropdownItem class="d-block py-2" routerLink="">
        <div class="d-flex justify-content-between mb-1">
          <span class="small">{{ task.title }} </span>
          <span class="fw-semibold">{{ task.value }}%</span>
        </div>
        <c-progress thin [value]="task.value" color="{{task.color}}-gradient" />
      </a>
      }
      <div class="px-2 pt-2">
        <button cButton color="primary" variant="outline" class="w-100" routerLink="">
          View all tasks
        </button>
      </div>
    </div>
  </c-dropdown>
</ng-template>

<!-- <ng-template #languageDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle disabled>
      <svg cIcon name="cilLanguage" size="lg"></svg>
    </button>
    <div cDropdownMenu></div>
  </c-dropdown>
</ng-template> -->

<ng-template #themeDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button [caret]="false" cDropdownToggle>
      @switch (colorMode()) {
      @case ("dark") {
      <svg cIcon name="cilMoon" size="lg"></svg>
      }
      @case ("auto") {
      <svg cIcon name="cilContrast" size="lg"></svg>
      }
      @default {
      <svg cIcon name="cilSun" size="lg"></svg>
      }
      }
    </button>
    <div cDropdownMenu>
      <button (click)="colorMode.set('light')" [active]="colorMode()==='light'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilSun" size="lg"></svg>
        Light
      </button>
      <button (click)="colorMode.set('dark')" [active]="colorMode()==='dark'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilMoon" size="lg"></svg>
        Dark
      </button>
      <button (click)="colorMode.set('auto')" [active]="colorMode()==='auto'" [routerLink]="[]" cDropdownItem
        class="d-flex align-items-center">
        <svg cIcon class="me-2" name="cilContrast" size="lg"></svg>
        Auto
      </button>
    </div>
  </c-dropdown>
</ng-template>